<script lang="ts" setup>
  import { computed, nextTick, ref, watch } from 'vue';

  const props = defineProps<{ secondsLeft: string }>();

  const lowTimeThreshold = 5;

  const isLowTime = computed(() => parseInt(props.secondsLeft) <= lowTimeThreshold);

  const isAnimating = ref(false);
  const timerRef = ref<HTMLElement | null>(null);

  watch(
    () => props.secondsLeft,
    async () => {
      isAnimating.value = false;
      await nextTick();
      void timerRef.value?.getBoundingClientRect();
      isAnimating.value = true;
    },
    { immediate: true },
  );
</script>

<template>
  <div
    ref="timerRef"
    :class="{
      'low-time': isLowTime,
      heartbeat: isAnimating && !isLowTime,
      'heartbeat-big': isAnimating && isLowTime,
    }"
    class="countdown"
  >
    {{ secondsLeft }}
  </div>
</template>

<style scoped>
  .countdown {
    --width-of-two-digits: 1.625rem;

    font-size: var(--font-size-lg);
    font-variant-numeric: tabular-nums;
    font-weight: var(--font-weight-strong);
    min-width: var(--width-of-two-digits);
    text-align: right;
    transition: color 0.3s ease;
  }

  .countdown.low-time {
    color: var(--color-primary);
  }

  .heartbeat {
    animation: heartbeat 0.3s ease-in-out;
  }

  .heartbeat-big {
    animation: heartbeat-big 0.3s ease-in-out;
  }

  @keyframes heartbeat {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.1);
    }

    100% {
      transform: scale(1);
    }
  }

  @keyframes heartbeat-big {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.3);
    }

    100% {
      transform: scale(1);
    }
  }
</style>
